import React from 'react';
import { Button, CircularProgress } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';

/**
 * Botón para cargar vigilantes del admin actual (comportamiento original)
 * @param {Object} props - Propiedades del componente
 * @param {Function} props.onClick - Función a ejecutar al hacer clic
 * @param {boolean} props.isLoading - Estado de carga
 * @returns {JSX.Element}
 */
const AdminVigilantesButton = ({ onClick, isLoading }) => {
  return (
    <Button
      variant="outlined"
      onClick={onClick}
      disabled={isLoading}
      startIcon={isLoading ? <CircularProgress size={20} /> : <PersonIcon />}
      sx={{
        marginRight: '10px',
        backgroundColor: 'white',
        color: '#6c757d',
        border: '1px solid #6c757d',
        '&:hover': {
          backgroundColor: '#f8f9fa',
          borderColor: '#5a6268'
        }
      }}
    >
      {isLoading ? 'Cargando...' : 'Usuarios con mis permisos'}
    </Button>
  );
};

export default AdminVigilantesButton;